
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireafa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireafa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aS58T", function(module, exports) {
parcelRequire("jpAna");
parcelRequire("8rDt9");
parcelRequire("1jE2f");

});
parcelRegister("jpAna", function(module, exports) {


var $24DUY = parcelRequire("24DUY");
document.querySelectorAll('.copy').forEach((elem)=>{
    elem.addEventListener('click', ()=>{
        // Check if the clipboard api is supported
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!navigator.clipboard) return;
        (0, $24DUY.discard)(navigator.clipboard.writeText(elem.innerText));
    });
});

});
parcelRegister("24DUY", function(module, exports) {

$parcel$export(module.exports, "discard", function () { return $98f5a1a913bcd35b$export$584af591d945b55a; });
const $98f5a1a913bcd35b$var$error = console.error.bind(console);
function $98f5a1a913bcd35b$export$584af591d945b55a(p) {
    p.then(()=>{}).catch($98f5a1a913bcd35b$var$error);
}
function $98f5a1a913bcd35b$export$7603b7d5ef1ac1a7(m, worker) {
    $98f5a1a913bcd35b$export$584af591d945b55a(m.runExclusive(worker));
}

});


parcelRegister("8rDt9", function(module, exports) {
document.querySelectorAll('span').forEach((elem)=>{
    if (!elem.hasAttribute('data-reveal')) return;
    $b2abed9af550e40c$export$7365a963a6092e93(elem, 10000);
});
function $b2abed9af550e40c$export$7365a963a6092e93(span, hideDelay) {
    const content = span.getAttribute('data-reveal') ?? '(no content)';
    let isHidden = true;
    // handler to hide the element
    const hide = ()=>{
        isHidden = true;
        span.innerText = '(click to reveal)';
    };
    hide();
    const reveal = ()=>{
        isHidden = false;
        const code = document.createElement('code');
        code.append(content);
        code.addEventListener('click', (evt)=>{
            evt.preventDefault();
            // Check if the clipboard api is supported
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (!navigator.clipboard) return;
            navigator.clipboard.writeText(content).then(()=>{}).catch(console.error.bind(console));
        });
        code.style.userSelect = 'all';
        span.innerHTML = '';
        span.append(code);
    };
    span.addEventListener('click', (evt)=>{
        evt.preventDefault();
        if (!isHidden) return;
        reveal();
        setTimeout(hide, hideDelay) // hide again after 1 second
        ;
    });
}

});

parcelRegister("1jE2f", function(module, exports) {
document.querySelectorAll('input[data-filter-list]').forEach((element)=>{
    const filterListAttribute = element.dataset.filterList;
    if (typeof filterListAttribute !== 'string' || !/^[a-zA-Z_-]+$/.test(filterListAttribute)) {
        console.warn('Element', element, 'has invalid or missing data-filter-list attribute', filterListAttribute);
        return;
    }
    const dimMode = element.dataset.filterMode === 'dim';
    element.form?.addEventListener('submit', (ev)=>ev.preventDefault());
    const selector = '*[' + CSS.escape(filterListAttribute) + ']';
    /**
     * Check if the given element matches a query
     * @param element Element to check
     * @param lowercaseQuery Query to match. Assumed to be lowercase.
     * @returns
     */ const matches = (element, lowercaseQuery)=>{
        if (lowercaseQuery.length === 0) return true;
        const value = element.getAttribute(filterListAttribute)?.toLowerCase();
        if (typeof value !== 'string') return true;
        // simple fuzzy match
        let j = 0;
        const len = lowercaseQuery.length;
        for(let i = 0; i < value.length && j < len; i++){
            if (value[i] !== lowercaseQuery[j]) continue;
            j++;
        }
        return j === len;
    };
    /**
     * Updates the view to display only elements matching the query.
     * @param lowercaseQuery Query to match against. Assumed to be lowercase.
     */ const updateFilter = (lowercaseQuery)=>{
        document.querySelectorAll(selector).forEach((candidate)=>{
            const matched = matches(candidate, lowercaseQuery);
            if (dimMode) candidate.classList.toggle('filter-dimmed', !matched);
            else if (matched) candidate.style.display = '';
            else candidate.style.display = 'none';
        });
    };
    element.addEventListener('input', (ev)=>{
        ev.preventDefault();
        const target = ev.currentTarget;
        updateFilter(target.value.toLowerCase());
    });
});

});



parcelRequire("aS58T");

//# sourceMappingURL=User.32d10e25.js.map
